/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon16Light = forwardRef('ArrowADownRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12 11.293V5.5a.5.5 0 0 1 1 0v6a1.5 1.5 0 0 1-1.5 1.5h-6a.5.5 0 0 1 0-1h5.793L3.146 3.854a.5.5 0 1 1 .708-.708L12 11.293Z" })));
});
